import { render, staticRenderFns } from "./ProdukAdd.vue?vue&type=template&id=650e7a00&scoped=true"
import script from "./ProdukAdd.vue?vue&type=script&lang=js"
export * from "./ProdukAdd.vue?vue&type=script&lang=js"
import style0 from "./ProdukAdd.vue?vue&type=style&index=0&id=650e7a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e7a00",
  null
  
)

export default component.exports